import { useEffect, useRef, useState } from "react";

/**
 * Reusable hook for scroll-triggered fade/slide-in animations.
 * Attach the returned ref to the section element, and apply
 * the returned `visible` boolean as a class (e.g. "visible").
 */
export default function useScrollReveal(threshold = 0.8) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1, rootMargin: `0px 0px -${(1 - threshold) * 100}% 0px` }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, visible];
}